import * as Yup from 'yup'

export const creditAllocationTxSchemas = Yup.object().shape({
  creditValue: Yup.number().optional(),
  externalTransactionId: Yup.number(),
  ident: Yup.string(),
  cashier: Yup.string().optional(),
  guid: Yup.string().optional(),
  transactionDate: Yup.string().optional(),
  comments: Yup.string().optional(),
  traceNumber: Yup.number().optional(),
  reasonId: Yup.number().optional(),
})
